import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { SubscriptionsApi } from '@intelingu/core/api/SubscriptionsApi';
import Helpers from '@intelingu/core/helpers/Helpers';
import { SubscriptionModel } from '@intelingu/core/interfaces/models/SubscriptionModel';
import { lazyInject } from '@intelingu/core/IoC/container';
import {COMMON_NS} from "@intelingu/core/constants/base.constants";
import withTranslation from "@intelingu/core/utils/withTranslation";

export interface SubscribedPageProps {
    t?;
}

@withTranslation(COMMON_NS)
@observer export class SubscribedPage extends Component<SubscribedPageProps, any> {

    render() {
        return <div className={'static-page thank-you-page'}>
            <h3 className={'mt-3'}>ERFOLG! DU BIST JETZT INTELINGU VOLL-MITGLIED</h3>

            <p>
                Du kannst ab sofort den vollen Funktionsumfang von Intelingu nutzen. Wir sind davon überzeugt, dass dies die beste Sprachlern-Entscheidung deines Lebens war.
            </p>

            <div>
                <Link to={'/'} className={'btn btn-primary'}>zur Kurs-Übersicht</Link>
            </div>
        </div>
    }

}
